var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-margin-bottom-xsmall"},[_c('h4',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"u-color-muted"},[_c('small',[_vm._v(" "+_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }